import { motion } from "framer-motion";

export default function SmoothSkinGraph() {
  return (
    <div className="w-full h-[300px] flex items-center justify-center bg-pink-50 rounded-xl relative overflow-hidden">
      {/* Y Axis */}
      <motion.div
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 1 }}
        transition={{ duration: 0.8 }}
        className="absolute bottom-8 left-8 w-0.5 h-[80%] bg-gray-300 origin-bottom"
      />

      {/* X Axis */}
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="absolute bottom-8 left-8 h-0.5 w-[85%] bg-gray-300 origin-left"
      />

      {/* Vertical gray dividers */}

      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "80%", opacity: 1 }}
        transition={{ delay: 0.5 }}
        className={`absolute bottom-8 left-[37%] w-0.5 bg-gray-200`}
      />
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "80%", opacity: 1 }}
        transition={{ delay: 0.5 }}
        className={`absolute bottom-8 left-[66%] w-0.5 bg-gray-200`}
      />
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "80%", opacity: 1 }}
        transition={{ delay: 0.5 }}
        className={`absolute bottom-8 left-[92.5%] w-0.5 bg-gray-200`}
      />

      {/* Milestone dots and labels */}
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.5 }}
        className={`absolute left-[6%] bottom-[55%] flex items-center gap-2 z-50`}
      >
        <span
          className={`absolute left-[80%] bottom-[100%] px-2 py-1 max-w-20 rounded-md text-xs font-medium bg-pink-400 text-white`}
        >
          smoother skin
        </span>
        <div
          className={`w-6 h-6 rounded-full border-2 border-white bg-pink-400`}
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 3, direction: 1 }}
        className={`absolute left-[34%] bottom-[43%] flex items-center gap-2 z-50`}
      >
        <span
          className={`absolute left-[80%] bottom-[100%] px-2 py-1 max-w-20 rounded-md text-xs font-medium bg-pink-400 text-white`}
        >
          reversing wrinkles
        </span>
        <div
          className={`w-6 h-6 rounded-full border-2 border-white bg-pink-400`}
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 4.5, direction: 1 }}
        className={`absolute left-[63%] bottom-[30%] flex items-center gap-2 z-50`}
      >
        <span
          className={`absolute inline-block left-[80%] w-24 bottom-[100%] px-2 py-1 rounded-md text-xs font-medium bg-pink-400 text-white`}
        >
          your best skin
        </span>
        <div
          className={`w-6 h-6 rounded-full border-2 border-white bg-green-500`}
        />
      </motion.div>

      {/* Curve Line Animation */}
      <motion.svg
        width="38%" // Можно оставить как есть, т.к. viewBox уменьшен
        height="75%"
        viewBox="0 0 100 50" // уменьшили в 3 раза (300 -> 100, 150 -> 50)
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute left-8 top-8 overflow-visible"
      >
        <motion.path
          // S-образная кривая с небольшим наклоном вниз в конце
          d="M0 10 C 25 40, 50 5, 75 40"
          stroke="#ec4899" // сплошной розовый цвет
          strokeWidth="3"
          fill="none"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{
            duration: 2,
            delay: 1.5,
            ease: "easeInOut",
          }}
          strokeLinecap="round"
        />
      </motion.svg>

      <motion.svg
        width="38%"
        height="75%"
        viewBox="0 0 100 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute left-[38%] bottom-2 overflow-visible"
      >
        <motion.path
          d="M0 10 C 25 40, 50 5, 75 40"
          stroke="url(#grad1)" // Используем градиент
          strokeWidth="3"
          fill="none"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{
            duration: 2,
            delay: 2.8,
            ease: "easeInOut",
          }}
          strokeLinecap="round"
        />
        <defs>
          <linearGradient
            id="grad1"
            x1="0"
            y1="0"
            x2="100"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#ec4899" /> {/* розовый */}
            <stop offset="100%" stopColor="#22c55e" /> {/* зелёный */}
          </linearGradient>
        </defs>
      </motion.svg>

      <motion.svg
        width="36%"
        height="75%"
        viewBox="0 0 100 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute left-[65%] top-[33%] overflow-visible"
      >
        <motion.path
          d="M0 10 C 25 40, 50 40, 75 35"
          stroke="#22c55e" // Зелёный цвет
          strokeWidth="3"
          fill="none"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{
            duration: 2,
            delay: 4,
            ease: "easeInOut",
          }}
          strokeLinecap="round"
        />
      </motion.svg>
    </div>
  );
}
